export default "__VITE_ASSET__CeTGP$rD__"